












































































import Vue, { PropOptions } from 'vue'

import BaseImage from '@/common/components/BaseImage.vue'
import ModalThumbnailPreview from '@/common/components/ThumbnailPreviewModal.vue'

import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import {
  productInfo_printableSku as ProductInfoModel
} from '@/groupBuy/queries/types'

export default Vue.extend({
  components: {
    BaseImage,
    ModalThumbnailPreview
  },
  props: {
    product: {
      type: Object,
      required: true
    } as PropOptions<ProductInfoModel>,
    psi: {
      type: [Number, String],
      required: true
    },
    linkTitle: {
      type: Boolean,
      default: true
    }
  },
  data(): {
    isShowThumbnailPreviewModal: boolean
    toggleContent: boolean
  }{
    return {
      isShowThumbnailPreviewModal: false,
      toggleContent: window.innerWidth > 600 ? true : false
    }
  },
  computed: {
    placeholder() {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    firstOption(): string {
      return this.product.sku.firstSelectionOption?.displayName || ''
    },
    colorPattern(): string {
      return this.product.skuColorPattern.colorPattern.displayName
    },
    productBrand(): string {
      return this.product.sku.product.brand || ''
    },
    sizeList(): string {
      return this.product.sku.availableSizes.map(item => item.name).join(' / ')
    },
    productName(): string {
      return this.product.sku.product.displayName
    },
    productUrl(): string {
      return `${this.product.sku.product.url}?psi=${this.psi}`
    },
    thumbnail(): string {
      return this.product.sku.firstSelectionOption?.thumbnail || ''
    },
    editPattern(): string {
      return this.product.skuEditPattern.editPattern.displayName
    }
  },
  methods: {
    openThumbnail() {
      this.isShowThumbnailPreviewModal = true
    }
  }
})
